import { BaggageType } from '@websky/graphql';
import { Money } from '../types';
import { PassengerSelectedGdsServicesFragment } from '@websky/graphql';

export enum Measurement {
	Kilograms = 'kg',
	Pieces = 'pcs'
}

export interface Baggage {
	id: string;
	segmentIds: string[][];
	allowedPassengers: string[];
	type: BaggageType;
	name: string;
	description?: string;
	value: {
		prefix?: string;
		amount: number;
		measurement: Measurement;
	};
	size: string;
	included: number;
	includedSegments?: string[];
	price: Money;
	canBeAdded: boolean;
	rfics: string;
	isRecommended?: boolean;
	isReplacedBy?: string[];
}

export interface SelectedBaggageItem {
	id?: string;
	count?: number;
	serviceId?: string;
	segmentIds?: string[];
	passengerId?: string;
	confirmedCount?: number;
	baggage?: Baggage;
}

export interface SelectedBaggage {
	[baggageId: string]: {
		[segmentId: string]: SelectedBaggageItem;
	};
}

export interface SelectedExtraSeat extends Partial<PassengerSelectedGdsServicesFragment> {
	passengerId: string;
}

export interface SportsEquipment {
	price: Money;
	isSelected: boolean;
}

export interface AdditionalService {
	baggage: Baggage;
	label: string;
	productId?: string;
	isSelected?: boolean;
}

export interface BaggageCount {
	[serviceId: string]: number;
}

export enum AdditionalTypes {
	'Overweight',
	'Sport',
	'HandLuggageExcess'
}
